import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { searchPurchaseItemReport } from "../../../actions/purchase";
import RenderTable from "./RenderTable";
import Excelldownload from "./Excelldownload";
import ReactToPrint from "react-to-print";
import dateFormat from "dateformat";

import {
    Layout,
    Breadcrumb,
    Row,
    Col,
    DatePicker,
    Space,
    Select,
    Divider,
    Skeleton,
    AutoComplete,
    Button,
} from "antd";

const { RangePicker } = DatePicker;
const { Option } = Select;

const PurchaseItemReport = ({
    searchPurchaseItemReport,
    businessprofile,
}) => {
    var formatter = new Intl.NumberFormat("en-IN");
    const componentRef = useRef();
    const [details, setdetails] = useState([]);
    const [data, setdata] = useState([]);
    const [loading, setloading] = useState(true);
    const [type, setType] = useState("date");
    const start = useRef("");
    const end = useRef("");
    const keyword = useRef("");
    const [reload, setreload] = useState(false);
    const pageno = useRef(1);
    const page_size = useRef(10);
    let total_data = useRef({});

    const onChange = (data) => {
        keyword.current = data;
        setreload(!reload);
    };

    useEffect(() => {
        searchPurchaseItemReport(
            start.current,
            end.current,
            keyword.current,
            pageno.current,
            page_size.current
        ).then(function (result) {
            total_data.current = {
                total_quantity: result.total_quantity,
                total_purchase_price: result.total_purchase_price,
                total_selling_price: result.total_selling_price,
                total_items: result.total_items,
                current_page_quantity: result.current_page_quantity,
                current_page_purchase_price: result.current_page_purchase_price,
                current_page_selling_price: result.current_page_selling_price,
            };

            setdata(result.results);
            setdetails(result);
            setloading(false);
        });
    }, [reload]);

    const renderdata = () => {
        if (loading) {
            return <Skeleton active />;
        } else {
            return (
                <RenderTable
                    details={details}
                    pageno={pageno}
                    page_size={page_size}
                    setreload={setreload}
                    reload={reload}
                    setloading={setloading}
                    total_data={total_data}
                />
            );
        }
    };

    const rendetable = () => {
        if (loading) {
            return <Skeleton active />;
        } else {
            return (
                <table className="product_table invoice_print_fontSize">
                    <tr>
                        <td>SL.</td>
                        <td>Date</td>
                        <td>PO No.</td>
                        <td>Item Code</td>
                        <td>Item Title</td>
                        <td>Size</td>
                        <td>Category</td>
                        <td>Quantity</td>
                        <td>Purchase Price</td>
                        <td>Selling Price</td>
                    </tr>

                    {data.map((item, index) => {
                        return (
                            <>
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{item.purchase_date}</td>
                                    <td>{item.purchase_number}</td>
                                    <td>{item.Item}</td>
                                    <td>{item.item_title}</td>
                                    <td>{item.size}</td>
                                    <td>{item.category}</td>
                                    <td>{item.quantity}</td>
                                    <td>{item.purchase_price}</td>
                                    <td>{item.selling_price}</td>
                                </tr>
                            </>
                        );
                    })}
                    <tr>
                        <td colSpan={7}>Total: </td>
                        <td>{total_data.current["total_quantity"]}</td>
                        <td>{total_data.current["total_purchase_price"]}</td>
                        <td>{total_data.current["total_selling_price"]}</td>
                    </tr>
                </table>
            );
        }
    };

    const renderresult = () => {
        if (loading) {
            return <Skeleton active />;
        } else {
            return (
                <Row>
                    <Col span={20}>
                        <table style={{ width: "30%" }}>
                            <tr>
                                <td>
                                    <b>Total Items :</b>{" "}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {" "}
                                    {formatter.format(total_data.current["total_items"])}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Total Quantity :</b>{" "}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {" "}
                                    {formatter.format(total_data.current["total_quantity"])}
                                </td>
                            </tr>
                            {/* <tr>
                                <td>
                                    <b>Total Purchase Price :</b>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {" "}
                                    {formatter.format(total_data.current["total_purchase_price"])}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <b>Total Selling Price : </b>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                    {formatter.format(total_data.current["total_selling_price"])}
                                </td>
                            </tr> */}
                            <tr>
                                <td colSpan={6}></td>
                            </tr>
                        </table>
                    </Col>
                    <Col span={2}>
                        <Excelldownload data={data} />
                    </Col>
                    <Col span={2}>
                        <ReactToPrint
                            trigger={() => <Button type="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                        <div style={{ display: "none" }}>
                            <div
                                className="invoice_print_fontSize"
                                ref={componentRef}
                                style={{ padding: "10px" }}
                            >
                                <Row
                                    style={{
                                        borderBottom: "2px solid lightgray",
                                        paddingBottom: "5px",
                                        marginBottom: "20px",
                                    }}
                                >
                                    <Col span={17} style={{ paddingTop: "10px" }}>
                                        <small>
                                            <div
                                                style={{ lineHeight: "2.5px" }}
                                                dangerouslySetInnerHTML={{
                                                    __html: businessprofile.address,
                                                }}
                                            ></div>
                                        </small>
                                    </Col>

                                    <Col span={7} style={{ textAlign: "right" }}>
                                        <img
                                            src={businessprofile.logo}
                                            style={{
                                                maxHeight: "60px",
                                            }}
                                        />
                                    </Col>
                                </Row>

                                <h3 style={{ textAlign: "center" }}>Purchase Item Report</h3>
                                <Row>
                                    <Col span={12} style={{ textAlign: "left" }}>
                                        {start.current != "" ? (
                                            <>
                                                From : {dateFormat(start.current, "mmmm dS, yyyy")}
                                                <br></br>
                                            </>
                                        ) : (
                                            ""
                                        )}

                                        {end.current != "" ? (
                                            <>
                                                To : {dateFormat(end.current, "mmmm dS, yyyy")}
                                                <br></br>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </Col>
                                    <Col span={12} style={{ textAlign: "right" }}></Col>
                                </Row>
                                {rendetable()}
                            </div>
                        </div>
                    </Col>
                </Row>
            );
        }
    };

    return (
        <>
            <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>Purchase Item Report</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
                <Row>
                    <Col span={8}>
                        <AutoComplete
                            placeholder="Search by product, item, PO number, or supplier"
                            onChange={onChange}
                            style={{ width: "100%" }}
                        />
                    </Col>
                    <Col span={10} offset={1}>
                        <Space>
                            Date range :
                            <RangePicker
                                picker={type}
                                onChange={(value) => {
                                    if (value) {
                                        start.current =
                            value[0].format("YYYY-MM-DD") + "T00:00:00Z";
                        end.current = value[1].format("YYYY-MM-DD") + "T23:59:59Z";
                                        setreload(!reload);
                                    }
                                }}
                            />
                            <Select value={type} onChange={setType}>
                                <Option value="date">Date</Option>
                                <Option value="month">Month</Option>
                                <Option value="year">Year</Option>
                            </Select>
                        </Space>
                    </Col>
                </Row>
                <Divider />
                {renderresult()}
                <Divider />
                {renderdata()}
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        businessprofile: state.settings.businessprofile,
    };
};

export default connect(mapStateToProps, {
    searchPurchaseItemReport,
})(PurchaseItemReport);
